import AddCommentScreen from '@/screens/AddCommentScreen';
import BuildingFormV2Screen from '@/screens/BuildingFormV2Screen';
import CameraScreen from '@/screens/CameraScreen/CameraScreen';
import ChallengeConquerTargetPlacesScreen from '@/screens/ChallengeConquerTargetPlacesScreen';
import ChallengeDetailScreen from '@/screens/ChallengeDetailScreen';
import ConquererHistoryScreen from '@/screens/ConquererHistoryScreen';
import ConquererMonthlyScreen from '@/screens/ConquererMonthlyScreen';
import ConquererScreen from '@/screens/ConquererScreen';
import ConquererUpVoteScreen from '@/screens/ConquererUpVoteScreen';
import CrusherActivityScreen from '@/screens/CrusherActivity';
import ToiletDetailScreen from '@/screens/ToiletDetailScreen';
import PlaceListDetailScreen from '@/screens/PlaceListDetailScreen';
import GuideForFirstVisitScreen from '@/screens/GuideForFirstVisitScreen';
import ImageZoomViewerScreen from '@/screens/ImageZoomViewerScreen';
import IntroScreen from '@/screens/IntroScreen';
import LoginScreen from '@/screens/LoginScreen';
import MainScreen from '@/screens/MainScreen';
import PastSeasonDetailScreen from '@/screens/PastSeasonDetail';
import PlaceDetailV2Screen from '@/screens/PlaceDetailV2Screen';
import PlaceFormV2Screen from '@/screens/PlaceFormV2Screen';
import FavoritePlacesScreen from '@/screens/FavoritePlacesScreen';
import MySavesScreen from '@/screens/MySavesScreen';
import PlacePhotoGuideScreen from '@/screens/PlacePhotoGuideScreen';
import PlaceReviewFormScreen from '@/screens/PlaceReviewFormScreen';
import ReportCorrectionFormScreen from '@/screens/ReportCorrectionFormScreen';
import { ProfileEditorDetailScreen } from '@/screens/ProfileEditorScreen';
import ProfileEditorScreen from '@/screens/ProfileEditorScreen/ProfileEditorScreen';
import RegistrationCompleteScreen from '@/screens/RegistrationCompleteScreen';
import ReviewHistoryScreen from '@/screens/ReviewHistoryScreen';
import ReviewScreen from '@/screens/ReviewScreen';
import ReviewUpVoteScreen from '@/screens/ReviewUpVoteScreen';
import SearchUnconqueredPlacesScreen from '@/screens/SearchUnconqueredPlacesScreen';
import SettingScreen from '@/screens/SettingScreen';
import SignupScreen from '@/screens/SignupScreen';
import BasicUsageTutorialScreen from '@/screens/BasicUsageTutorialScreen';
import TutorialMissionScreen from '@/screens/TutorialMissionScreen';
import TutorialUpvoteAccessibilityMissionScreen from '@/screens/TutorialUpvoteAccessibilityMissionScreen';
import EditInterestedRegionScreen from '@/screens/EditInterestedRegionScreen';
import EditInterestedThemesScreen from '@/screens/EditInterestedThemesScreen';
import InterestedRegionAndThemesFormScreen from '@/screens/InterestedRegionAndThemesFormScreen';
import PublicPlaceListsScreen from '@/screens/PublicPlaceListsScreen';
import ToiletReviewFormScreen from '@/screens/ToiletReviewFormScreen';
import UpvoteAnalyticsScreen from '@/screens/UpvoteAnalyticsScreen';
import ResolvingSharedLinkScreen from '@/screens/ResolvingSharedLinkScreen';
import ResolvingSccContentScreen from '@/screens/ResolvingSccContentScreen';
import WebViewScreen from '@/screens/WebViewScreen';
export const MainNavigationScreens = [
    { name: 'Intro', component: IntroScreen },
    { name: 'Main', component: MainScreen },
    {
        name: 'Login',
        component: LoginScreen,
        // asModal(다른 화면 위에 띄우는 로그인)일 때만 모달로 표시한다.
        // Webview 처럼 presentation: 'fullScreenModal' 로 뜬 화면 위에 기본 push 로 올리면
        // 네이티브 모달이 위에 남아 로그인 화면이 가려진다 → 유저에겐 "버튼 눌러도 아무 반응
        // 없음" 으로 보이고, 그 상태에서 X 를 누르면 위에 쌓인 Login 이 먼저 pop 돼서 두 번
        // 눌러야 웹뷰가 닫힌다. (asModal 이 아닌 진입 — Intro/Main 의 replace, 로그아웃 reset —
        //  은 기존 push 그대로 둔다)
        options: ({ route }) => { var _a; return ((_a = route.params) === null || _a === void 0 ? void 0 : _a.asModal) ? { presentation: 'fullScreenModal' } : {}; },
    },
    {
        name: 'Signup',
        component: SignupScreen,
        // 미가입 유저는 Login 이 Signup 으로 replace 되므로 asModal 도 그대로 이어진다.
        // Login 과 같은 이유로 모달로 띄워야 한다 (안 그러면 웹뷰 모달 뒤에 가려져
        // "아무 반응 없음" + X 두 번 눌러야 닫힘).
        options: ({ route }) => {
            var _a;
            return (Object.assign({ headerShown: true, headerTitle: '' }, (((_a = route.params) === null || _a === void 0 ? void 0 : _a.asModal)
                ? { presentation: 'fullScreenModal' }
                : {})));
        },
    },
    {
        name: 'Setting',
        component: SettingScreen,
        options: { headerShown: true, headerTitle: '설정' },
    },
    {
        name: 'Review',
        component: ReviewScreen,
        options: { headerShown: true, headerTitle: '내 리뷰' },
    },
    {
        name: 'Review/History',
        component: ReviewHistoryScreen,
        options: { headerShown: true, headerTitle: '내가 작성한 리뷰' },
    },
    {
        name: 'Review/Upvote',
        component: ReviewUpVoteScreen,
        options: { headerShown: true, headerTitle: '도움이 돼요' },
    },
    {
        name: 'Conquerer',
        component: ConquererScreen,
        options: { headerShown: true, headerTitle: '정복한 장소' },
    },
    {
        name: 'Conquerer/History',
        component: ConquererHistoryScreen,
        options: { headerShown: true, headerTitle: '내가 정복한 장소' },
    },
    {
        name: 'Conquerer/Upvote',
        component: ConquererUpVoteScreen,
        options: { headerShown: true, headerTitle: '도움이 돼요' },
    },
    {
        name: 'UpvoteAnalytics',
        component: UpvoteAnalyticsScreen,
        options: { headerShown: true, headerTitle: '도움돼요' },
    },
    { name: 'Camera', component: CameraScreen, options: { freezeOnBlur: true } },
    {
        name: 'CrusherActivity',
        component: CrusherActivityScreen,
        options: { headerShown: true, headerTitle: '크러셔 활동' },
    },
    {
        name: 'PastSeasonDetail',
        component: PastSeasonDetailScreen,
        options: { headerShown: true, headerTitle: '크러셔 활동' },
    },
    {
        name: 'PlaceFormV2',
        component: PlaceFormV2Screen,
        options: {
            headerShown: true,
            headerTitle: '장소 접근성 입력하기',
            variant: 'close',
            gestureEnabled: false,
        },
    },
    { name: 'PlaceDetailV2', component: PlaceDetailV2Screen },
    {
        name: 'ToiletDetail',
        component: ToiletDetailScreen,
    },
    {
        name: 'BuildingFormV2',
        component: BuildingFormV2Screen,
        options: {
            headerShown: true,
            headerTitle: '건물 정보 등록하기',
            variant: 'close',
            gestureEnabled: false,
        },
    },
    {
        name: 'AddComment',
        component: AddCommentScreen,
        options: { headerShown: true, headerTitle: '의견 추가하기' },
    },
    {
        name: 'ChallengeDetail',
        component: ChallengeDetailScreen,
        options: { headerShown: true, headerTitle: '챌린지' },
    },
    {
        name: 'ChallengeConquerTargetPlaces',
        component: ChallengeConquerTargetPlacesScreen,
        options: { headerShown: false, freezeOnBlur: true },
    },
    {
        name: 'ProfileEditor',
        component: ProfileEditorScreen,
        options: { headerShown: true, headerTitle: '프로필 수정' },
    },
    {
        name: 'ProfileEditor/Detail',
        component: ProfileEditorDetailScreen,
        options: { headerShown: true, headerTitle: '' },
    },
    // modals
    {
        name: 'Conquerer/Monthly',
        component: ConquererMonthlyScreen,
        options: { presentation: 'modal' },
    },
    // fullscreen modals
    {
        name: 'GuideForFirstVisit',
        component: GuideForFirstVisitScreen,
        options: { presentation: 'fullScreenModal' },
    },
    {
        name: 'PlacePhotoGuide',
        component: PlacePhotoGuideScreen,
        options: {
            presentation: 'fullScreenModal',
        },
    },
    {
        name: 'Webview',
        component: WebViewScreen,
        options: { presentation: 'fullScreenModal' },
    },
    {
        name: 'MySaves',
        component: MySavesScreen,
        options: { headerShown: true, headerTitle: '내 저장' },
    },
    {
        name: 'FavoritePlaces',
        component: FavoritePlacesScreen,
        options: { headerShown: true, headerTitle: '내가 저장한 장소' },
    },
    {
        name: 'PlaceListDetail',
        component: PlaceListDetailScreen,
        options: { headerShown: false, freezeOnBlur: true },
    },
    {
        // deep link 하위호환: place-group/:id → PlaceListDetail
        name: 'PlaceGroupMap',
        component: PlaceListDetailScreen,
        options: { headerShown: false, freezeOnBlur: true },
    },
    {
        name: 'SearchUnconqueredPlaces',
        component: SearchUnconqueredPlacesScreen,
        options: { headerShown: false, freezeOnBlur: true },
    },
    {
        name: 'ImageZoomViewer',
        component: ImageZoomViewerScreen,
        options: { presentation: 'fullScreenModal' },
    },
    {
        name: 'RegistrationComplete',
        component: RegistrationCompleteScreen,
        // 기본 push/pop slide 애니메이션으로 통일 (fullScreenModal 사용 시 닫을 때
        // 모달 vertical dismiss → pop 애니메이션이 겹쳐 파란 배경이 노출됨).
        options: { headerShown: false, gestureEnabled: false },
    },
    {
        name: 'BasicUsageTutorial',
        component: BasicUsageTutorialScreen,
        options: {
            headerShown: false,
            gestureEnabled: false,
        },
    },
    {
        name: 'TutorialMission',
        component: TutorialMissionScreen,
        options: {
            headerShown: true,
            headerTitle: '튜토리얼',
        },
    },
    {
        name: 'InterestedRegionAndThemes',
        component: InterestedRegionAndThemesFormScreen,
        options: {
            headerShown: true,
            headerTitle: '',
            variant: 'close',
        },
    },
    {
        name: 'EditInterestedRegion',
        component: EditInterestedRegionScreen,
        options: {
            headerShown: true,
            headerTitle: '',
        },
    },
    {
        name: 'EditInterestedThemes',
        component: EditInterestedThemesScreen,
        options: {
            headerShown: true,
            headerTitle: '',
        },
    },
    {
        name: 'PublicPlaceLists',
        component: PublicPlaceListsScreen,
        options: {
            headerShown: true,
            headerTitle: '저장리스트 모음',
            variant: 'close',
        },
    },
    {
        // 튜토리얼 미션 2 (SAVE_PLACE_LIST) 전용 라우트. PublicPlaceListsScreen 컴포넌트를
        // 그대로 재사용하지만 fromTutorial=true 컨텍스트가 라우트 이름으로 명시되어 일반
        // 진입 (홈에서 PublicPlaceLists 직접 진입) 과 분리된다. 진입 컨텍스트가 분명하니
        // 자식 PlaceListDetail 에서도 fromTutorial chain 으로 미션 완료 트리거 여부를 판단한다.
        name: 'TutorialMissionSavePlaceList',
        component: PublicPlaceListsScreen,
        options: {
            headerShown: true,
            headerTitle: '저장리스트 모음',
            variant: 'close',
        },
    },
    {
        name: 'TutorialUpvoteAccessibilityMission',
        component: TutorialUpvoteAccessibilityMissionScreen,
        options: {
            // 화면 내부에서 V2AppBar 를 직접 sticky 로 렌더하므로 native header 는 숨긴다.
            headerShown: false,
        },
    },
    {
        name: 'ReportCorrectionForm',
        component: ReportCorrectionFormScreen,
        options: {
            headerShown: true,
            headerTitle: '정보 수정 신고',
            variant: 'close',
            gestureEnabled: false,
        },
    },
    {
        name: 'ReviewForm/Place',
        component: PlaceReviewFormScreen,
        options: {
            headerShown: true,
            headerTitle: '방문 후기 작성하기',
            variant: 'close',
            gestureEnabled: false,
        },
    },
    {
        name: 'ReviewForm/Toilet',
        component: ToiletReviewFormScreen,
        options: {
            headerShown: true,
            headerTitle: '화장실 정보 작성하기',
            variant: 'close',
            gestureEnabled: false,
        },
    },
    {
        name: 'ResolvingSharedLink',
        component: ResolvingSharedLinkScreen,
        options: { headerShown: false },
    },
    {
        name: 'ResolvingSccContent',
        component: ResolvingSccContentScreen,
        options: { headerShown: false },
    },
];
